import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InteractiveLinkContentComponent } from './interactive-link-content.component';
import { ButtonModule } from '../form/button/button.module';
import { CopyToClipboardModule } from '../copy-to-clipboard/copy-to-clipboard.module';
import { TextfieldComponent } from '../form/textfield/textfield.component';



@NgModule({
    declarations: [
        InteractiveLinkContentComponent,
    ],
    imports: [
        CommonModule,
        ButtonModule,
        CopyToClipboardModule,
        TextfieldComponent
    ],
    exports: [
        InteractiveLinkContentComponent
    ]
})

export class InteractiveLinkContentModule { }
